import React, { Component } from "react";

import X_BARReportView from "../../../components/Common/X-BARReportView";

class OBARReport extends Component {
  render() {
    return (
      <X_BARReportView
        {...this.props}
        location={this.props.location}
        patientId={this.props.match.params.patientId}
        reportType="obar"
      />
    );
  }
}

export default OBARReport;
